import { getToken } from "../utils/auth";
import { API_BASE_URL } from "./URL_Header";

const authHeaders = (json = true) => {
  const headers = { Authorization: `Bearer ${getToken()}` };
  if (json) headers["Content-Type"] = "application/json";
  return headers;
};

async function readError(response) {
  try {
    const data = await response.json();
    return data.message || data.title || `خطأ ${response.status}`;
  } catch {
    return `خطأ ${response.status}`;
  }
}

export const fetchNotifications = async ({ page = 0, pageSize = 20, unreadOnly = false } = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    pageSize: String(pageSize),
    unreadOnly: unreadOnly ? "true" : "false",
  });
  const response = await fetch(`${API_BASE_URL}/notifications?${params}`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchUnreadNotificationCount = async () => {
  const response = await fetch(`${API_BASE_URL}/notifications/unread-count`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  const data = await response.json();
  return data.count ?? 0;
};

export const markNotificationRead = async (id) => {
  const response = await fetch(`${API_BASE_URL}/notifications/${id}/read`, {
    method: "POST",
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const markAllNotificationsRead = async () => {
  const response = await fetch(`${API_BASE_URL}/notifications/read-all`, {
    method: "POST",
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchNotificationPreferences = async () => {
  const response = await fetch(`${API_BASE_URL}/notifications/preferences`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const updateNotificationPreference = async (type, enabled) => {
  const response = await fetch(`${API_BASE_URL}/notifications/preferences`, {
    method: "PUT",
    headers: authHeaders(true),
    body: JSON.stringify({ type, enabled }),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const registerNotificationDevice = async (device) => {
  const response = await fetch(`${API_BASE_URL}/notifications/register-device`, {
    method: "POST",
    headers: authHeaders(true),
    body: JSON.stringify(device),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};

export const fetchNotificationDevices = async () => {
  const response = await fetch(`${API_BASE_URL}/notifications/devices`, {
    headers: authHeaders(false),
  });
  if (!response.ok) throw new Error(await readError(response));
  return response.json();
};
